import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=b2bb8242&"
import script from "./FilePicker.vue?vue&type=script&lang=ts&"
export * from "./FilePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports